module.exports = __webpack_public_path__ + "img/mada.6a1bbabf.png";